let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9wxKg"), load("btCqR"), load("107zu"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));